var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-stripe" },
    [
      _vm.showManualFlow
        ? _c(
            "ManualFlow",
            {
              ref: _vm.refsName.manualFlow,
              attrs: {
                title: _vm.$t("account.settings.manual-flow.title"),
                callback: _vm.saveAntifraudSettings,
                loading: _vm.accountLoading,
                hideEditButton: !_vm.permissionIsEnabled(
                  "settings.manual_flow:edit"
                ),
              },
              on: {
                cancelEdit: function ($event) {
                  return _vm.resetObject(
                    _vm.manualFlow,
                    _vm.functionalitiesSettings.manualFlow
                  )
                },
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("account.settings.manual-flow.config")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_nonessential _size_small",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.manual-flow.config-detail"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "emd-form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "emd-label",
                            attrs: { for: "enableManual" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("account.settings.manual-flow.status")
                              )
                            ),
                          ]
                        ),
                        _c("span", { staticClass: "emd-input-helper" }),
                        _c(
                          "label",
                          {
                            staticClass: "emd-switcher__label",
                            attrs: { for: "enableManual" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.manualFlow.manual_flow,
                                  expression: "manualFlow.manual_flow",
                                },
                              ],
                              staticClass: "emd-switcher _color_success",
                              attrs: { type: "checkbox", id: "enableManual" },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.manualFlow.manual_flow
                                )
                                  ? _vm._i(_vm.manualFlow.manual_flow, null) >
                                    -1
                                  : _vm.manualFlow.manual_flow,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toogleAlertInfo(
                                    _vm.refsName.manualFlow
                                  )
                                },
                                change: function ($event) {
                                  var $$a = _vm.manualFlow.manual_flow,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.manualFlow,
                                          "manual_flow",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.manualFlow,
                                          "manual_flow",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.manualFlow, "manual_flow", $$c)
                                  }
                                },
                              },
                            }),
                            _c("div", { staticClass: "emd-switcher__area" }),
                            _c("span", { staticClass: "emd-switcher__text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("account.settings.manual-flow.active")
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm.showNotifications
        ? _c(
            "notifications",
            {
              ref: _vm.refsName.notifications,
              attrs: {
                title: _vm.$t("account.settings.notifications.title"),
                callback: _vm.saveNotificationsSettings,
                loading: _vm.accountLoading,
                formIsInvalid: _vm.$v.notifications.$invalid,
                hideEditButton: !_vm.permissionIsEnabled(
                  "settings.notifications:edit"
                ),
              },
              on: {
                cancelEdit: function ($event) {
                  return _vm.resetObject(
                    _vm.notifications,
                    _vm.functionalitiesSettings.notifications
                  )
                },
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.notifications.config"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_nonessential _size_small",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.notifications.config-detail"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "emd-form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "emd-label",
                            attrs: { for: "enableNotifications" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("account.settings.notifications.status")
                              )
                            ),
                          ]
                        ),
                        _c("span", { staticClass: "emd-input-helper" }),
                        _c(
                          "label",
                          {
                            staticClass: "emd-switcher__label",
                            attrs: { for: "enableNotifications" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.notifications.enabled,
                                  expression: "notifications.enabled",
                                },
                              ],
                              staticClass: "emd-switcher _color_success",
                              attrs: {
                                type: "checkbox",
                                id: "enableNotifications",
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.notifications.enabled
                                )
                                  ? _vm._i(_vm.notifications.enabled, null) > -1
                                  : _vm.notifications.enabled,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toogleAlertInfo(
                                    _vm.refsName.notifications
                                  )
                                },
                                change: function ($event) {
                                  var $$a = _vm.notifications.enabled,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.notifications,
                                          "enabled",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.notifications,
                                          "enabled",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.notifications, "enabled", $$c)
                                  }
                                },
                              },
                            }),
                            _c("div", { staticClass: "emd-switcher__area" }),
                            _c("span", { staticClass: "emd-switcher__text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.notifications.active"
                                  )
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm.permissionIsEnabled("settings.guaranteed_cancelation:view")
        ? _c(
            "guaranteed-cancellation",
            {
              ref: _vm.refsName.guaranteedCancellation,
              attrs: {
                title: _vm.$t("account.settings.cancellation.title"),
                callback: _vm.saveCancellationSettings,
                loading: _vm.accountLoading,
                formIsInvalid: _vm.$v.cancellation.$invalid,
                hideEditButton: !_vm.permissionIsEnabled(
                  "settings.guaranteed_cancelation:edit"
                ),
              },
              on: {
                cancelEdit: function ($event) {
                  return _vm.resetObject(
                    _vm.cancellation,
                    _vm.functionalitiesSettings.cancellation
                  )
                },
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("account.settings.cancellation.config")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_nonessential _size_small",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.cancellation.config-detail"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "emd-form-group" }, [
                        _c("label", { staticClass: "emd-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("account.settings.cancellation.status")
                            )
                          ),
                        ]),
                        _c(
                          "label",
                          {
                            staticClass: "emd-switcher__label",
                            attrs: { for: "enabledGuaranteedCancelation" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cancellation.enabled,
                                  expression: "cancellation.enabled",
                                },
                              ],
                              staticClass: "emd-switcher _color_success",
                              attrs: {
                                type: "checkbox",
                                id: "enabledGuaranteedCancelation",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.cancellation.enabled)
                                  ? _vm._i(_vm.cancellation.enabled, null) > -1
                                  : _vm.cancellation.enabled,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toogleAlertInfo(
                                    _vm.refsName.guaranteedCancellation
                                  )
                                },
                                change: function ($event) {
                                  var $$a = _vm.cancellation.enabled,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.cancellation,
                                          "enabled",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.cancellation,
                                          "enabled",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.cancellation, "enabled", $$c)
                                  }
                                },
                              },
                            }),
                            _c("div", { staticClass: "emd-switcher__area" }),
                            _c("span", { staticClass: "emd-switcher__text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("account.settings.cancellation.active")
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm.showCheckout
        ? _c(
            "checkout",
            {
              ref: _vm.refsName.checkout,
              attrs: {
                title: _vm.$t("account.settings.checkout.title"),
                callback: _vm.saveCheckoutSettings,
                loading: _vm.accountLoading,
                formIsInvalid: _vm.$v.checkout.$invalid,
                hideEditButton: !_vm.permissionIsEnabled(
                  "settings.checkout:edit"
                ),
                alertInfoFixed: _vm.checkout.checkout_enabled,
              },
              on: {
                cancelEdit: function ($event) {
                  return _vm.resetObject(
                    _vm.checkout,
                    _vm.functionalitiesSettings.checkout
                  )
                },
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("account.settings.checkout.config")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm.permissionIsEnabled("settings.checkout:edit")
                      ? _c("div", { staticClass: "emd-panel__block" }, [
                          _c("div", { staticClass: "el-chunk" }, [
                            _c("div", { staticClass: "emd-form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "emd-label",
                                  attrs: { for: "status" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("account.settings.checkout.status")
                                    )
                                  ),
                                ]
                              ),
                              _c(
                                "label",
                                {
                                  staticClass: "emd-switcher__label",
                                  attrs: { for: "enableCheckout" },
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.checkout.checkout_enabled,
                                        expression: "checkout.checkout_enabled",
                                      },
                                    ],
                                    staticClass: "emd-switcher _color_success",
                                    attrs: {
                                      type: "checkbox",
                                      id: "enableCheckout",
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.checkout.checkout_enabled
                                      )
                                        ? _vm._i(
                                            _vm.checkout.checkout_enabled,
                                            null
                                          ) > -1
                                        : _vm.checkout.checkout_enabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.fixedAlertInfo(
                                          _vm.refsName.checkout
                                        )
                                      },
                                      change: function ($event) {
                                        var $$a = _vm.checkout.checkout_enabled,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.checkout,
                                                "checkout_enabled",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.checkout,
                                                "checkout_enabled",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.checkout,
                                            "checkout_enabled",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _c("div", {
                                    staticClass: "emd-switcher__area",
                                  }),
                                  _vm.checkout.checkout_enabled
                                    ? _c(
                                        "span",
                                        { staticClass: "emd-switcher__text" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "account.settings.checkout.active"
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_nonessential _size_small",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.checkout.address-type-detail"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c("label", { staticClass: "emd-label _required" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("account.settings.checkout.address-type")
                              )
                            ),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "emd-select",
                              class: {
                                _state_error:
                                  _vm.$v.checkout.address_type.$invalid,
                              },
                              attrs: { id: "addressType" },
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.checkout.address_type,
                                      expression: "checkout.address_type",
                                    },
                                  ],
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.checkout,
                                        "address_type",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                _vm._l(
                                  _vm.addressTypes,
                                  function (address, index) {
                                    return _c(
                                      "option",
                                      {
                                        key: index,
                                        domProps: { value: index },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t(address)) + " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                              _c("div", { staticClass: "emd-select__arrow" }),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_nonessential _size_small",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.checkout.enable-brands-detail"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              attrs: { for: "status" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.checkout.enable-brands"
                                  )
                                )
                              ),
                            ]
                          ),
                          _c(
                            "label",
                            {
                              staticClass: "emd-switcher__label",
                              attrs: { for: "enableBrands" },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.checkout.brands_enabled,
                                    expression: "checkout.brands_enabled",
                                  },
                                ],
                                staticClass: "emd-switcher _color_success",
                                attrs: { type: "checkbox", id: "enableBrands" },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.checkout.brands_enabled
                                  )
                                    ? _vm._i(
                                        _vm.checkout.brands_enabled,
                                        null
                                      ) > -1
                                    : _vm.checkout.brands_enabled,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.checkout.brands_enabled,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.checkout,
                                            "brands_enabled",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.checkout,
                                            "brands_enabled",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.checkout,
                                        "brands_enabled",
                                        $$c
                                      )
                                    }
                                  },
                                },
                              }),
                              _c("div", { staticClass: "emd-switcher__area" }),
                              _c(
                                "span",
                                { staticClass: "emd-switcher__text" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("account.settings.checkout.active")
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm.checkout.brands_enabled
                    ? _c("div", { staticClass: "emd-panel__section" }, [
                        _c("div", { staticClass: "emd-panel__block" }, [
                          _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "emd-text _color_nonessential _size_small",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "account.settings.checkout.enabled-brands-detail"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "emd-panel__block" }, [
                          _c("div", { staticClass: "el-chunk" }, [
                            _c(
                              "div",
                              { staticClass: "emd-form-group" },
                              [
                                _c("jade-checkbox-group", {
                                  attrs: {
                                    items: _vm.acceptedBrands,
                                    label: _vm.$t(
                                      "account.settings.checkout.enabled-brands"
                                    ),
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_nonessential _size_small",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.checkout.required-fields-detail"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "div",
                          { staticClass: "emd-form-group" },
                          [
                            _c("jade-checkbox-group", {
                              attrs: {
                                label: _vm.$t(
                                  "account.settings.checkout.required-fields"
                                ),
                                items: _vm.requiredFields,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm.permissionIsEnabled("settings.split:view")
        ? _c(
            "split",
            {
              ref: _vm.refsName.split,
              attrs: {
                title: _vm.$t("account.settings.split.title"),
                callback: _vm.saveSplitSettings,
                loading: _vm.accountLoading,
                formIsInvalid: _vm.$v.split.$invalid,
                hideEditButton: !_vm.permissionIsEnabled("settings.split:edit"),
              },
              on: {
                cancelEdit: function ($event) {
                  return _vm.resetObject(
                    _vm.split,
                    _vm.functionalitiesSettings.split
                  )
                },
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("account.settings.split.config")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_nonessential _size_small",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("account.settings.split.config-detail")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c("div", { staticClass: "emd-form-group" }, [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              attrs: { for: "status" },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("account.settings.split.status"))
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "emd-input-helper" }),
                          _c(
                            "label",
                            {
                              staticClass: "emd-switcher__label",
                              attrs: { for: "enableSplit" },
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.split.enabled,
                                    expression: "split.enabled",
                                  },
                                ],
                                staticClass: "emd-switcher _color_success",
                                attrs: { type: "checkbox", id: "enableSplit" },
                                domProps: {
                                  checked: Array.isArray(_vm.split.enabled)
                                    ? _vm._i(_vm.split.enabled, null) > -1
                                    : _vm.split.enabled,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toogleAlertInfo(
                                      _vm.refsName.split
                                    )
                                  },
                                  change: function ($event) {
                                    var $$a = _vm.split.enabled,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.split,
                                            "enabled",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.split,
                                            "enabled",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.split, "enabled", $$c)
                                    }
                                  },
                                },
                              }),
                              _c("div", { staticClass: "emd-switcher__area" }),
                              _c(
                                "span",
                                { staticClass: "emd-switcher__text" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("account.settings.split.active")
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }